var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSolarWarningTriangleBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54134 7.17467C5.48667 3.72467 6.45934 2 8 2C9.54 2 10.5133 3.72467 12.4587 7.17467L12.7013 7.604C14.318 10.4707 15.1267 11.904 14.396 12.952C13.6653 14 11.8573 14 8.24267 14H7.75734C4.14267 14 2.33467 14 1.604 12.952C0.873336 11.904 1.682 10.4707 3.29867 7.604L3.54134 7.17467ZM8 4.83333C8.13261 4.83333 8.25979 4.88601 8.35356 4.97978C8.44732 5.07355 8.5 5.20073 8.5 5.33333V8.66667C8.5 8.79927 8.44732 8.92645 8.35356 9.02022C8.25979 9.11399 8.13261 9.16667 8 9.16667C7.86739 9.16667 7.74022 9.11399 7.64645 9.02022C7.55268 8.92645 7.5 8.79927 7.5 8.66667V5.33333C7.5 5.20073 7.55268 5.07355 7.64645 4.97978C7.74022 4.88601 7.86739 4.83333 8 4.83333ZM8 11.3333C8.17681 11.3333 8.34638 11.2631 8.47141 11.1381C8.59643 11.013 8.66667 10.8435 8.66667 10.6667C8.66667 10.4899 8.59643 10.3203 8.47141 10.1953C8.34638 10.0702 8.17681 10 8 10C7.82319 10 7.65362 10.0702 7.5286 10.1953C7.40357 10.3203 7.33334 10.4899 7.33334 10.6667C7.33334 10.8435 7.40357 11.013 7.5286 11.1381C7.65362 11.2631 7.82319 11.3333 8 11.3333Z",
    fill: "#FF5630"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSolarWarningTriangleBold);
export default __webpack_public_path__ + "static/media/ic-solar_warning-triangle-bold.80134c89e43603692f2985fddf1d4870.svg";
export { ForwardRef as ReactComponent };